/**
 * Muted caption/label on white or light chart surfaces.
 * Global MUI `palette.text.secondary` stays legacy (`defaultTheme.color.light`);
 * use this where Typography must read on light card backgrounds.
 */
export const chartMutedTextOnLight = 'rgba(0, 0, 0, 0.6)';
